import axiosInstance from "./axiosInstance";

const documentService = {
    create: async (payload) => {
        try {
            const response = await axiosInstance.post('/documents/doccreate', payload);
            return response.data
        } catch (error) {
            throw error.response.data
        }
    },
    fetchDocAll: async () => {
        try {
            const response = await axiosInstance.get('/documents/docall');
            return response.data
        } catch (error) {
            throw error.response.data
        }
    },
}

export default documentService